export default __webpack_public_path__ + "static/media/emerald.510117cd.svg";